import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Zap } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { finishGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        await finishGoogle(sessionId);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
        toast.success("Signed in with Google");
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/login"), 1500);
      }
    })();
  }, [finishGoogle, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-background">
      <div className="text-center">
        <span className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl bg-primary/10 p-2"><img src="/adgen-logo-v2.png" alt="AdGen Store" className="h-full w-full object-contain" /></span>
        {error ? (
          <p className="text-sm text-muted-foreground">Sign-in failed. Redirecting…</p>
        ) : (
          <p className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Completing sign-in…</p>
        )}
      </div>
    </div>
  );
}
